import { cn } from '../../lib/cn';
import type { OrderIntelRow } from '../../customerops/framework';

type Props = { rows?: OrderIntelRow[] };

export function OrderIntelligencePanel({ rows = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {rows.map((r) => (
        <div key={r.dimension} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{r.dimension}</p>
          <p className="mt-1 text-lg font-semibold">{r.value}</p>
          <p className={cn('text-xs font-medium', r.positive ? 'text-success-600' : 'text-error-600')}>{r.trend}</p>
        </div>
      ))}
    </div>
  );
}
